<template>
  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <div class="mydoc">
      <div class="header" style="font-weight: 900">
        {{ $t('risingStar.headerTitle') }}
      </div>
      <div class="mybody">
        <p v-for="(paragraph, index) in $t('risingStar.announcement').split('\n')" :key="index">
          {{ paragraph }}
        </p>
        <p>
          <span
            style="cursor: pointer; color: #006a71"
            @click="downloadPaper()"
          >{{ $t('risingStar.download') }}</span>
        </p>
        
        <p>
         <span
          style="cursor: pointer; color: #006a71"
          @click="openFile('http://www.exp-linguistics.net/file/第一届“赵元任语言实验之星”评奖结果.pdf')"
         >{{ $t('risingStar.result1') }}</span>
        </p>
        
        <p>
         <span
          style="cursor: pointer; color: #006a71"
          @click="openFile('http://www.exp-linguistics.net/file/第二届“赵元任语言实验之星”评奖结果.pdf')"
         >{{ $t('risingStar.result2') }}</span>
        </p>
        <p>
         <span
          style="cursor: pointer; color: #006a71"
          @click="openFile('http://www.exp-linguistics.net/file/第三届“赵元任语言实验之星”评奖结果.pdf')"
         >{{ $t('risingStar.result3') }}</span>
        </p>

      </div>
    </div>
  </el-col>
</template>

<script>
import loginComponent from "@/components/loginComponent";

export default {
  name: "star",
  components: {
    loginComponent,
  },
  data() {
    return {}
  },
  methods: {
    downloadPaper () {
      window.open(
        "http://www.exp-linguistics.net/file/“语言实验之星奖”推荐书.docx",
        "_blank"
      )
    },
    openFile (url) {
      window.open(encodeURI(url), "_blank")
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/star.vue